import { render, staticRenderFns } from "./DataTableTextColumn.vue?vue&type=template&id=1e7d13ca&"
import script from "./DataTableTextColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableTextColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports